import { useContext, useEffect } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { OnboardingContext } from '../../store/context';

export const useLoadMocks = () => {
  const [, { SET_LOADED_SNAPSHOTS }] = useContext(OnboardingContext);
  const { userSettings = {} } = useOtherSettings();
  const { isOnboardingEnabled = false } = userSettings;

  useEffect(() => {
    if (isOnboardingEnabled) {
      // R.I.P.
      // import('../../mocks/storesSnapshots/index.js').then(
      //   ({ MOCKED_STORES_SNAPSHOTS }) =>
      //     SET_LOADED_SNAPSHOTS(MOCKED_STORES_SNAPSHOTS)
      // );
    }
  }, [isOnboardingEnabled, SET_LOADED_SNAPSHOTS]);
};
